import React from "react";
import { isDateFilter } from "../../../lib/filterTypes";
import { Chip } from "./Chip";
import { RangeChip } from "./RangeChip";

export const DateChip = React.forwardRef((props, ref) => {
    let { title, trans, filterValue, } = props,
        { icon = "calendar-range", iconFamily = "material-community"} = props,
        chipProps = {
            ...props,
            icon,
            iconFamily
        }

    if (!isDateFilter(filterValue?.filterType)) {
        return <RangeChip { ...chipProps } />
    }

    title = `${title}: ${trans(`filters.date.${filterValue?.filterType}`)}`;

    return <Chip ref={ref} { ...chipProps } title={title} tooltip={title} />
})